// "The Reranker Fixes the Confidently-Wrong #1" — Voyage cross-encoder short.
// Cold Compute / Neon kit. ~102s @ 30fps. Every claim grounded in EAKC-MVP:
// src/lib/rag/reranker.ts (LLM batch scorer, BATCH_SIZE=5), cross-encoder-rerank.ts
// (RERANK_PROVIDER=voyage, rerank-2.5, fail-open), and the 2026-07-24 A/B + the
// RerankScorer instrument fix (the trace reports which scorer ACTUALLY ran).
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  the #1 was 95% sure. and wrong.
  problem: { start: 150, duration: 570 }, //   0:05–0:24  the old reranker: an LLM EMULATING a cross-encoder
  intuition: { start: 720, duration: 360 }, // 0:24–0:36  a real cross-encoder reads (query, chunk) together
  approach: { start: 1080, duration: 480 }, // 0:36–0:52  Voyage rerank-2.5 · one call · flag-gated · fail-open
  ab: { start: 1560, duration: 570 }, //       0:52–1:11  the A/B: 1100ms → 484ms, quality parity
  catch: { start: 2130, duration: 600 }, //    1:11–1:31  429 → fails OPEN, and the trace now tells you
  outro: { start: 2730, duration: 330 }, //    1:31–1:42
} as const;

export const TOTAL_DURATION = 3060; // 102s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
